export default __webpack_public_path__ + "46df5b0c9d40e95ce52c38badf3b910f.png";